import { format } from "date-fns";

/**
 * Formats a Date for the scheduling API, which reads `start_time`/`end_time`
 * as office wall-clock time. The trailing `Z` is part of the expected shape,
 * not a UTC conversion — `toISOString()` here would shift by the browser
 * offset and query the wrong window.
 */
export const formatApiDatetime = (date: Date): string =>
  `${format(date, "yyyy-MM-dd'T'HH:mm:ss")}Z`;
